/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
export class RowSelectionCache {
  static _data = [];
  static unselectedData = [];

  static getData() {
    return this._data.slice(0);
  }

  static getUnselectedData() {
    return this.unselectedData.slice(0);
  }

  static clear() {
    this._data = [];
    this.unselectedData = [];
  }

  static onChange(api, isInterface) {
    let unSelectedNodes = [],
      i,
      index,
      len;
    api.forEachNode((node) => {
      let idValue = isInterface ? node.data.masterId : node.data.id;
      if (!node.isSelected()) {
        unSelectedNodes.push(idValue);
      } else {
        index = this._data.indexOf(idValue);
        if (index === -1) {
          this._data.push(idValue);
          let unselectedDataIndex = this.unselectedData.findIndex(id => id == idValue);
          if (unselectedDataIndex > -1) {
            this.unselectedData.splice(unselectedDataIndex, 1)
          }
        }
      }
    });
    len = unSelectedNodes.length;
    for (i = 0; i < len; i++) {
      index = this._data.indexOf(unSelectedNodes[i]);
      if (index !== -1) {
        this._data.splice(index, 1);
        if (this.unselectedData.findIndex(id => id == unSelectedNodes[i]) == -1) {
          this.unselectedData.push(unSelectedNodes[i])
        }

      }
    }
  }

  static updateOnRowDataChanged(api) {
    api.forEachNode((node) => {
      if (this._data.indexOf(node.data.id) !== -1 && !node.isSelected()) {
        node.setSelected(true);
      }
    });
  }
}
